import TableDataDesktop from "./TableDataDesktop";

export default TableDataDesktop;
